import { supabase } from '../../supabaseClient';
import { StatusOptionsEnum } from '../../screens/ModalBudget/utils/constants';
import { fetchAllRows } from './supabaseFetchAll';
import { transformOSToReportData } from './osReport';

const APPROVED_STATUSES = [
  StatusOptionsEnum.APROVADO,               // 3
  StatusOptionsEnum.APROVADO_PARCIALMENTE,  // 5
  StatusOptionsEnum.SERVIÇO_REALIZADO,      // 8
];

const round2 = (n) => Math.round(n * 100) / 100;
const safeDiv = (numerator, denominator) => (denominator > 0 ? numerator / denominator : 0);

// Puro e testável: recebe orçamentos (mesma estrutura da OS: service/ae_service/parts)
// e devolve os VALORES em R$ agregados por aprovação. Reusa o cálculo de total da OS
// (osReport), então bate com o "Total orçamento" do modal e com o relatório.
export const computeBudgetValueMetrics = (budgetRows) => {
  const totals = transformOSToReportData(budgetRows, []);
  let realizados = 0;
  let aprovados = 0;
  let qtdAprovados = 0;
  totals.forEach((t, i) => {
    realizados += t.total_os;
    if (APPROVED_STATUSES.includes(budgetRows[i].status)) {
      aprovados += t.total_os;
      qtdAprovados += 1;
    }
  });
  realizados = round2(realizados);
  aprovados = round2(aprovados);
  const naoAprovados = round2(realizados - aprovados);
  const qtdRealizados = budgetRows.length;
  const qtdNaoAprovados = qtdRealizados - qtdAprovados;
  const taxaConversao = round2(safeDiv(qtdAprovados, qtdRealizados) * 100);
  const ticketMedio = round2(safeDiv(realizados, qtdRealizados));
  return {
    realizados, aprovados, naoAprovados, taxaConversao, ticketMedio,
    qtdRealizados, qtdAprovados, qtdNaoAprovados,
  };
};

// Carrega os orçamentos da empresa por período (created_at) e calcula os valores.
export const loadBudgetValueMetrics = async (companyId, range) => {
  const empty = {
    realizados: 0, aprovados: 0, naoAprovados: 0, taxaConversao: 0, ticketMedio: 0,
    qtdRealizados: 0, qtdAprovados: 0, qtdNaoAprovados: 0,
  };
  if (!companyId || !range?.from || !range?.to) return empty;
  const { data, error } = await fetchAllRows(() =>
    supabase
      .from('Budget')
      .select(
        'id, status, service, ae_service, parts, bodyshop_discount, aesthetics_discount, parts_discount'
      )
      .eq('id_company', companyId)
      .is('deleted_at', null)
      .gte('created_at', `${range.from}T00:00:00`)
      .lte('created_at', `${range.to}T23:59:59`)
      .order('id', { ascending: true })
  );
  if (error || !data) return empty;
  return computeBudgetValueMetrics(data);
};
